import { Component } from '@angular/core';
import { AboutService } from '../../providers/about';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { AboutResult } from '../../entities/aboutResult';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})

export class AboutPage extends MainPage {
    public Version: string;
    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public aboutService: AboutService, 
        protected alertController: AlertController,
        protected userService: UserService,
        protected appCtrl: App) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.Version = "Carregando...";
        this.about();
    }

    public loadPage(): void {
        throw new Error("Method not implemented.");
    }

    about() {
        this.aboutService.about3().then((item) => {
            this.Version = (<AboutResult>item).Version;
        }).catch((err) => {
            this.getError(<ErrorResult>err);
        })
    };
}


// WEBPACK FOOTER //
// ./src/pages/about/about.ts